import React from "react";
import "../Css/WhyChooseUs.css";

import icon1 from "../assets/qua1.png";
import icon2 from "../assets/qua2.png";
import icon3 from "../assets/qua3.png";
import icon4 from "../assets/qua4.png";
import icon5 from "../assets/qua5.png";

const WhyChooseUs = () => {
  return (
    <section className="whychoose">

      {/* HEADER */}
      <div className="whychoose-header">
        <h2>Why IITian's Chinmay Academy ?</h2>

        {/* decorative circle */}
        <span className="why-circle"></span>
      </div>

      {/* CONTENT */}
      <div className="whychoose-container">

        <div className="why-card">
          <div className="icon-circle">
            <img src={icon1} alt="Qualified Faculty" />
          </div>
          <h3>Qualified & Experienced Faculties</h3>
          <p>
            Highly qualified tutors with years of teaching experience to guide
            students effectively.
          </p>
        </div>

        <div className="why-card">
          <div className="icon-circle">
            <img src={icon5} alt="Free Demo" />
          </div>
          <h3>Personal Coaching</h3>
          <p>
            Guidance and academic support provided for better comfort and focus.
          </p>
        </div>

        <div className="why-card">
          <div className="icon-circle">
            <img src={icon3} alt="Champion" />
          </div>
          <h3>Making your Child Champion</h3>
          <p>
            Focused learning approach to help your child achieve academic
            excellence.
          </p>
        </div>

        <div className="why-card">
          <div className="icon-circle">
            <img src={icon4} alt="Personalized Tutor" />
          </div>
          <h3>Personalized Tutor for your Child</h3>
          <p>
            One-to-one attention with customized teaching based on student needs.
          </p>
        </div>

        <div className="why-card">
          <div className="icon-circle">
            <img src={icon5} alt="Overall Development" />
          </div>
          <h3>Overall Development of your Child</h3>
          <p>
            We focus on confidence, concepts, discipline, and academic growth.
          </p>
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
